import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ABOUT, GALLERY_IMAGES } from "../lib/data";

const fadeUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] },
};

const About = () => (
  <div data-testid="about-page">
    <section className="px-6 md:px-12 lg:px-16 pt-24 md:pt-32 pb-16">
      <motion.div {...fadeUp} className="max-w-5xl">
        <p className="tracking-overline text-xs text-[#9A7456] mb-6">
          {ABOUT.eyebrow}
        </p>
        <h1
          className="font-display text-5xl md:text-7xl lg:text-8xl leading-[0.98] text-[#231F1E]"
          data-testid="about-title"
        >
          {ABOUT.headline}
        </h1>
      </motion.div>
    </section>

    <section className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 px-6 md:px-12 lg:px-16 pb-24 md:pb-32">
      <div className="lg:col-span-7 space-y-8">
        {ABOUT.paragraphs.map((p, i) => (
          <motion.p
            key={i}
            {...fadeUp}
            transition={{ duration: 0.8, delay: i * 0.08 }}
            className="font-body text-lg leading-[1.8] text-[#231F1E]/85 max-w-2xl"
          >
            {p}
          </motion.p>
        ))}
      </div>
      <motion.div {...fadeUp} className="lg:col-span-5">
        <div className="aspect-[4/5] media-zoom">
          <img
            src={GALLERY_IMAGES[7]?.src}
            alt="Workin Chix Events crowd"
            className="w-full h-full object-cover"
          />
        </div>
      </motion.div>
    </section>

    <section className="bg-[#231F1E] text-[#EDE6DA] px-6 md:px-12 lg:px-16 py-24 md:py-32">
      <p className="tracking-overline text-xs text-[#D6B66B] mb-12">
        What we stand on
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
        {ABOUT.pillars.map((p, i) => (
          <motion.div key={p.title} {...fadeUp} transition={{ duration: 0.8, delay: i * 0.12 }}>
            <div className="text-[#D6B66B] font-display text-6xl mb-4">
              0{i + 1}
            </div>
            <h3 className="font-display text-3xl mb-4">{p.title}</h3>
            <p className="font-body text-sm text-[#EDE6DA]/75 leading-relaxed">{p.copy}</p>
          </motion.div>
        ))}
      </div>
    </section>

    <section className="px-6 md:px-12 lg:px-16 py-24 md:py-32 text-center max-w-3xl mx-auto">
      <motion.div {...fadeUp}>
        <p className="tracking-overline text-xs text-[#9A7456] mb-5">Join us</p>
        <h2 className="font-display text-4xl md:text-5xl leading-tight mb-8">
          Come build the Bay Area's most curated market day with us.
        </h2>
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <a
            href="https://forms.gle/k5X22jtCcHQh2fZi6"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
            data-testid="about-vendor-cta"
          >
            Apply as a Vendor
          </a>
          <Link to="/markets" className="btn-secondary" data-testid="about-markets-cta">
            See Upcoming Markets
          </Link>
        </div>
      </motion.div>
    </section>
  </div>
);

export default About;
